import React, { useState, useMemo } from 'react';
import styled from 'styled-components';
import BarGraph from '../../../Common/BarGraph/BarGraph';
import GraphHOC from '../../../Common/GraphHOC/GraphHOC';
import RatingDonutChart from '../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../Common/FunnelGraph/FunnelGraph';
import TitleWithInfo from '../../../Common/TitleWithInfo/TitleWithInfo';
import CorrelationGraph from '../../../components/CorrelationGraph/CorrelationGraph';
import WordCloudAnalysis from '../../../components/InsightsWordCloud/WordCloudAnalysis';
import {
  emoji_neutral,
  emoji_surprise,
  emoji_joy,
  emoji_fear,
  emoji_sadness,
  emoji_anger,
  emoji_disgust,
} from '../../../Common/SvgIcon/CommonSvgIcons';
import VerticalBarGraph from '../../../Common/BarGraph/VarticalBargraph';
import SmallSelect from '../../../Common/Select/SmallSelect';
import { parse, format } from 'date-fns';
import { useParsedEndDate, useParsedStartDate } from '../../../utils/ParseDate';
import MapChart from '../../../components/Maps/WorldMap';

const Wrapper = styled.div`
  padding: 30px;
  margin-bottom: 50px;
  & .title {
    color: #636363;
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;
  }
`;

const EmotionAnalysisWrapper = styled.div`
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 0px 10px;
  align-items: center;
  margin-top: 30px;

  .titleContainer {
    margin: 25px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .correlationGraphContainer {
    padding: 1px 20px 20px 20px;
  }

  & > p:first-child {
    ${'' /* color: #636363; */}
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;

    margin: 20px 0px 0px 10px;
  }
`;

const FilteredGraphContainer = styled.div`
  flex: 1;
  display: flex;
  width: 100%;
  margin: 20px 0px 20px 50px;
  align-items: center;
`;

const Footer = styled.div`
  color: rgba(0, 0, 0, 0.87);
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 400;
  margin: 28px 0 20px 0;
  text-align: center;
`;

const FunnelGraphContaining = styled.div`
  width: 80%;
  height: 100%;
  margin: 20px;
`;

const GraphContainer = styled.div`
  margin: 10px 0px 0px 20px;
`;
const Insight = ({
  insights_data = {},
  startDate = '',
  endDate = '',
  filteredData,
  filterOption,
  filteredStartDate,
  filteredEndDate,
  view,
  resetFlag,
  channel,
  hideDropdown,
  is_news = false,
  formatValue = 'dd-yyyy-MM',
  search_type = '',
  job_id,
  handleTabClick,
}) => {
  const COLOR_RANGE_1 = [
    '#C4C4CD',
    '#87D3F2',
    '#4EBEEB',
    '#35B8E8',
    '#188CE6',
    '#1777CF',
    '#155CB4',
  ];

  const startDateParsed = useParsedStartDate(
    resetFlag,
    filteredStartDate,
    startDate,
    formatValue
  );
  const endDateParsed = useParsedEndDate(
    resetFlag,
    filteredEndDate,
    endDate,
    formatValue
  );

  if (Object.keys(insights_data).length === 0) {
    return (
      <h2
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '30px',
        }}
      >
        {/* No data available */}Insufficient Data
      </h2>
    );
  }

  const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];

  const emotionAnalysis = [
    {
      name: 'Neutral',
      value:
        resetFlag === true && filteredData
          ? filteredData?.emotion_analysis[0].neutral
          : insights_data?.emotion_analysis[0].neutral,
      // fill: '#F5CC61',
      fill: '#FDE3A2',
      // fill: 'rgba(251, 214, 121, 0.8)',
    },
    {
      name: 'Surprise',
      value:
        resetFlag === true && filteredData
          ? filteredData?.emotion_analysis[0].surprise
          : insights_data?.emotion_analysis[0].surprise,
      // fill: '#B7DC68',
      fill: '#4FD786',
      // fill: 'rgba(3, 198, 82, 0.8)',
    },
    {
      name: 'Joy',
      value:
        resetFlag === true && filteredData
          ? filteredData?.emotion_analysis[0].joy
          : insights_data?.emotion_analysis[0].joy,
      // fill: '#FE00D5',
      fill: '#E651CE',
      // fill: 'rgba(218, 6, 184, 0.8)',
    },
    {
      name: 'Fear',
      value:
        resetFlag === true && filteredData
          ? filteredData?.emotion_analysis[0].fear
          : insights_data?.emotion_analysis[0].fear,
      // fill: '#FC9E58',
      fill: '#FFB84D',
      // fill: 'rgba(255, 153, 0, 0.8)',
    },
    {
      name: 'Sadness',
      value:
        resetFlag === true && filteredData
          ? filteredData?.emotion_analysis[0].sadness
          : insights_data?.emotion_analysis[0].sadness,
      // fill: '#4B9AE9',
      fill: '#5C9BDB',
      // fill: 'rgba(21, 112, 203, 0.8)',
    },
    {
      name: 'Anger',
      value:
        resetFlag === true && filteredData
          ? filteredData?.emotion_analysis[0].anger
          : insights_data?.emotion_analysis[0].anger,
      // fill: '#F74945',
      fill: '#F14239',
      // fill: 'rgba(238, 19, 7, 0.8)',
    },
    {
      name: 'Disgust',
      value:
        resetFlag === true && filteredData
          ? filteredData?.emotion_analysis[0].disgust
          : insights_data?.emotion_analysis[0].disgust,

      fill: '#8862D3',
      // fill: 'rgba(84, 30, 192, 0.8)',
    },
  ];

  const renderScreen = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          data={emotionAnalysis}
          maxWidth={'70%'}
          type={'%'}
          title={'Emotional_Analysis'}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          drillThroughType={'emotion'}
          summary={
            resetFlag === true && filteredData
              ? filteredData?.emotion_summary
              : insights_data?.emotion_summary
          }
        />
      ) : (
        <BarGraph
          data={emotionAnalysis}
          maxWidth={'70%'}
          type={'%'}
          barHeight={'32px'}
          barHeightHover={'40px'}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          drillThroughType={'emotion'}
          emojiList={{
            neutral: emoji_neutral,
            surprise: emoji_surprise,
            joy: emoji_joy,
            fear: emoji_fear,
            sadness: emoji_sadness,
            anger: emoji_anger,
            disgust: emoji_disgust,
            length: 2,
          }}
          title={'Emotional_Analysis'}
          summary={
            resetFlag === true && filteredData
              ? filteredData?.emotion_summary
              : insights_data?.emotion_summary
          }
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        data={emotionAnalysis}
        width={500}
        type='percentage'
        title={'Emotional_Analysis'}
        summary={
          resetFlag === true && filteredData
            ? filteredData?.emotion_summary
            : insights_data?.emotion_summary
        }
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
      />
    ),
    'Donut Chart': (
      <DonutChart
        data={emotionAnalysis}
        type='percentage'
        title={'Emotional_Analysis'}
        summary={
          resetFlag === true && filteredData
            ? filteredData?.emotion_summary
            : insights_data?.emotion_summary
        }
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        data={emotionAnalysis}
        maxWidth={'80%'}
        type={'%'}
        title={'Emotional_Analysis'}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
        summary={
          resetFlag === true && filteredData
            ? filteredData?.emotion_summary
            : insights_data?.emotion_summary
        }
      />
    ),
  };

  return (
    <Wrapper>
      <WordCloudAnalysis
        showSwitchTab={false}
        insightsData={
          resetFlag === true && filteredData ? filteredData : insights_data
        }
        hideDropdown={hideDropdown}
        startDate={startDateParsed}
        endDate={endDateParsed}
        formatValue={formatValue}
        channel={channel}
        showKeyWordDropDown={false}
      />

      <EmotionAnalysisWrapper>
        <GraphHOC
          formatValue={formatValue}
          title={'Emotion Analysis'}
          options={options}
          renderScreen={renderScreen}
          graphWidth={'100%'}
          margin={'20px 0px 20px 50px'}
          startDate={startDateParsed}
          endDate={endDateParsed}
          option={filterOption}
          hideDropdown={hideDropdown}
          infoText={
            channel === 'instagram'
              ? 'The percentage distribution of seven unique user emotions expressed in comments.'
              : channel === 'facebook'
              ? 'The percentage distribution of seven unique user emotions expressed in posts.'
              : 'The percentage distribution of seven unique user emotions expressed in posts.'
          }
        />
      </EmotionAnalysisWrapper>

      {(is_news == true || channel === 'twitter') &&
        (filteredData?.map_data?.length > 0 ||
          insights_data?.map_data?.length > 0) && (
          <div style={{ marginTop: '30px' }}>
            <MapChart
              mapData={
                filteredData ? filteredData?.map_data : insights_data?.map_data
              }
              channel={channel}
              // text={`The majority of the engagers were from ${stateWithHighestReviews}`}
              colorRange={COLOR_RANGE_1}
              startDate={startDateParsed}
              job_id={job_id}
              handleTabClick={(data) => handleTabClick(data)}
              endDate={endDateParsed}
              infoText={
                'Track the total number of posts, likes, replies, views, and reposts across different geographies, offering a global view of user engagement.'
              }
            />
          </div>
        )}
    </Wrapper>
  );
};

export default Insight;
